// ⌘K хайлт: цэс (эрхээр), сурагч (код/нэр), эцэг эх. ↑↓ сонгох, Enter нээх, Esc хаах.
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "antd";
import { BiSearch } from "react-icons/bi";
import { instance } from "utils/axios";
import { useAccess } from "contexts/access";
import { filterMenu, flatMenu } from "../../menu";

export default function CommandPalette({ open, onClose }) {
  const navigate = useNavigate();
  const { can } = useAccess();
  const [q, setQ] = useState("");
  const [people, setPeople] = useState({ students: [], parents: [] });
  const [cur, setCur] = useState(0);
  const input = useRef(null);
  const timer = useRef(null);

  useEffect(() => { if (open) { setQ(""); setCur(0); setPeople({ students: [], parents: [] }); setTimeout(() => input.current?.focus(), 50); } }, [open]);
  useEffect(() => {
    clearTimeout(timer.current);
    const term = q.trim();
    if (term.length < 2) { setPeople({ students: [], parents: [] }); return undefined; }
    timer.current = setTimeout(() => {
      const get = (url, perm) => (can(...perm) ? instance({ method: "get", url, params: { q: term }, noMessage: true }).then((r) => r.data).catch(() => []) : Promise.resolve([]));
      Promise.all([get("/people/students", ["students", "own"]), get("/people/parents", ["parents", "own"])])
        .then(([s, p]) => setPeople({ students: (Array.isArray(s) ? s : s?.rows || []).slice(0, 6), parents: (Array.isArray(p) ? p : p?.rows || []).slice(0, 4) }));
    }, 250);
    return () => clearTimeout(timer.current);
  }, [q]); // eslint-disable-line react-hooks/exhaustive-deps

  const term = q.trim().toLowerCase();
  const pages = filterMenu(flatMenu(), can).filter((m) => !term || String(m.label?.props?.children || "").toLowerCase().includes(term)).slice(0, 6);
  const groups = [
    ["Сурагч", people.students.map((s) => ({ key: `s${s.id}`, t: `${s.lastName ? `${s.lastName[0]}. ` : ""}${s.firstName}`, m: [s.groupCode || s.grade, s.code].filter(Boolean).join(" · "), go: `/students/${s.id}` }))],
    ["Эцэг эх", people.parents.map((p) => ({ key: `p${p.id}`, t: p.name, m: (p.children || []).map((c) => c.firstName).join(", "), go: `/parents/${p.id}` }))],
    ["Цэс", pages.map((m) => ({ key: m.key, t: m.label?.props?.children, m: m.groupLabel || "", go: m.to }))],
  ].filter((g) => g[1].length);
  const hits = groups.flatMap((g) => g[1]);
  const pick = (h) => { onClose(); navigate(h.go); };
  const onKey = (e) => {
    if (e.key === "ArrowDown") { e.preventDefault(); setCur((c) => Math.min(hits.length - 1, c + 1)); }
    else if (e.key === "ArrowUp") { e.preventDefault(); setCur((c) => Math.max(0, c - 1)); }
    else if (e.key === "Enter" && hits[cur]) pick(hits[cur]);
  };
  let n = 0;

  return (
    <Modal open={open} onCancel={onClose} footer={null} closable={false} width={640} style={{ top: "12vh" }} bodyStyle={{ padding: 0 }} destroyOnClose>
      <label className="flex items-center gap-3 h-14 px-4 border-b border-gray-200">
        <BiSearch size={18} className="text-gray-500" aria-hidden="true" />
        <input ref={input} value={q} onChange={(e) => { setQ(e.target.value); setCur(0); }} onKeyDown={onKey} aria-label="Хайх"
          placeholder="Нэр, код, цэс…" className="flex-1 border-0 outline-none text-base bg-transparent min-w-0" />
        <kbd className="text-[11px] border border-gray-300 rounded px-1.5 font-sans">Esc</kbd>
      </label>
      <ul className="list-none m-0 p-1.5 max-h-[50vh] overflow-y-auto">
        {!hits.length && <li className="p-6 text-center text-gray-500">{term.length < 2 ? "Хайх үгээ бичнэ үү" : "Олдсонгүй"}</li>}
        {groups.map(([label, xs]) => (
          <React.Fragment key={label}>
            <li className="text-[10.5px] font-bold tracking-wider text-gray-500 px-2.5 pt-2 pb-1 uppercase">{label}</li>
            {xs.map((h) => {
              const i = n++;
              return (
                <li key={h.key}>
                  <button type="button" onMouseEnter={() => setCur(i)} onClick={() => pick(h)}
                    className={`flex items-center gap-3 w-full h-10 px-2.5 rounded-lg border-0 text-left cursor-pointer ${i === cur ? "bg-brand-50" : "bg-transparent"}`}>
                    <b className="truncate">{h.t}</b><span className="text-xs text-gray-500 truncate">{h.m}</span>
                  </button>
                </li>
              );
            })}
          </React.Fragment>
        ))}
      </ul>
      <div className="flex gap-4 px-4 py-2 border-t border-gray-200 text-xs text-gray-500 bg-gray-50"><span>↑↓ сонгох</span><span>↵ нээх</span><span>Esc хаах</span></div>
    </Modal>
  );
}
